<template>
    <div class="rated-password">
        <div class="rated-password__input" data-foo="bar">
            <input
            class="input rated-password-input"
            :class="hasError ? 'input--error' : ''" type="password"
            v-model="value"
            :required="required"
            :placeholder="placeholder"
            :id="id"
            :name="name">
        </div>
        <div class="rated-password__bar" v-if="value">
            <div class="rated-password__dynamic-line" :style="dynamicLineStyle"></div>
        </div>
        <div class="rated-password__hint" v-if="value">
            <div v-if="weak" data-test="weak">
                {{trans('passwords.weak_password')}}
            </div>
            <div v-else data-test="strong">
                {{trans('passwords.strong_password')}}
            </div>
            <div v-tippy :title="trans('passwords.validation', {countCharacter: 15})">
                <span>
                    <img src="/images/icons/info.svg" alt="Info Icon">
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                required: true
            },
            id: String,
            placeholder: String,
            required: Boolean,
            hasError: Boolean
        },
        data() {
            return {
                value: ''
            };
        },
        computed: {
            rating() {
                let ratingPercent = 0;

                if (this.value.length > 6) {
                   ratingPercent += 20;
                }

                if (this.value.length > 12) {
                   ratingPercent += 20;
                }

                if (this.value.length > 15) {
                   ratingPercent += 20;
                }

                if (this.value.match(/[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]+/)) {
                   ratingPercent += 10;
                }

                if (this.value.match(/[A-Z]/)) {
                   ratingPercent += 10;
                }

                if (this.value.match(/[a-z]/)) {
                   ratingPercent += 10;
                }

                if (this.value.match(/[0-9]/)) {
                   ratingPercent += 10;
                }

                return ratingPercent;
            },
            dynamicLineStyle() {

                return {
                    width: this.rating + '%',
                    backgroundColor: this.dynamicLineBackgroundColor
                }
            },
            dynamicLineBackgroundColor() {

                if (this.rating >= 90) {
                    return '#57ab27';
                }
                if (this.rating >= 75) {
                    return '#ffd500';
                }
                if (this.rating >= 50) {
                    return '#f19933';
                }
                return '#d02f2f';
            },
            weak() {
                return this.rating < 90;
            }

        },
    }
</script>
